import React, { useState } from 'react';
import OxygenOTPComponent from '../components/OxygenOTPComponent';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {sendOtp, validateOtp, checkEligibility } from "../services/oxygenRetailServices";
import useCustomAlert from "../components/Alert2";
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice";
import OxygenRecheckEligibilty from '../components/OxygenRecheckEligibilty';
import { updateCustomerOnboardingStat } from '../services/PrequalificationService';
import { setOtpLoading } from '../redux/features/oxygen/oxygenRetailSlice';
import { setShowModal } from '../redux/features/oxygen/customModalSlice';

const OxygenFormOTP = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customAlert = useCustomAlert();
  const [recheckEligibility, setRecheckEligibility] = useState(false);
  const [loading, setLoading] = useState(false);
  const storePrecustomer = useSelector(
    (state) => state?.precustomer?.precustomerData
  );

    const handleResendOTP = async() =>{
      const res = await sendOtp(storePrecustomer?.precustomer?.msisdn,storePrecustomer?.precustomer?.precustomerId);

      if(res.status === true) {
        customAlert.showToast("success", `${res?.message}` ||"OTP sent successfully, please check your phone for OTP"); 
      } else {
        customAlert.showToast("error", `${res?.message}` || "Failed to send OTP");
      }
    }

    const handleProceed = async(otp) =>{
      dispatch(setOtpLoading(true));
      const formData ={
        preCustomerId: String(storePrecustomer?.precustomer?.precustomerId),
      }
      // OTP Validation:
      const res = await validateOtp(otp, storePrecustomer?.precustomer?.msisdn, storePrecustomer?.precustomer?.precustomerId);

      if(res.status === true) {
        await updateCustomerOnboardingStat(
          storePrecustomer.precustomer?.msisdn,
          "OTP_VALIDATED"
        );
        customAlert.showToast("success", `${res?.message}`||"OTP validated successfully");

        // Eligibility check:
        const eligibilityResult = await checkEligibility(formData);

        if(eligibilityResult.status === true) {
          // Update precustomer
          dispatch(updatePrecustomer({
            precustomer:{
              ...storePrecustomer?.precustomer,
              precustomerId:storePrecustomer?.precustomer?.precustomerId,
              msisdn:storePrecustomer?.precustomer?.msisdn,
              eligibleAmount :eligibilityResult?.data?.eligible_amount,
              eligible_tenure:eligibilityResult?.data?.eligible_tenure,
              eligible:eligibilityResult?.data?.eligible
            },
            onboarding_status: "oxygen-device-bundles",
          }));
          
          // Make api call to update the onboarding status
          await updateCustomerOnboardingStat(
            storePrecustomer.precustomer?.msisdn,
            "ELIGIBILITY_PASS"
          );
          
          dispatch(setOtpLoading(false));
          customAlert.showToast("success", `${eligibilityResult?.message}`||"eligibility checked successfully");
          navigate("/oxygen-device-bundles");

        }else if(eligibilityResult?.status === false && eligibilityResult?.responseCode?.toLowerCase() === "pending"){
          // Make api call to update the onboarding status
          await updateCustomerOnboardingStat(
            storePrecustomer.precustomer?.msisdn,
            "OTP SENT."
          );
          dispatch(setOtpLoading(false));
          customAlert.showToast("error", `${eligibilityResult?.message}` || "Failed to check eligibility");
          setRecheckEligibility(true);

        }else if(eligibilityResult?.status === false && eligibilityResult?.responseCode?.toLowerCase() === "complete"){
          // Make api call to update the onboarding status
          await updateCustomerOnboardingStat(
            storePrecustomer.precustomer?.msisdn,
            "OTP SENT."
          );
          dispatch(setOtpLoading(false));
          customAlert.showToast("error", `${eligibilityResult?.message}` || "Failed to check eligibility");
          // confirmation modal
          dispatch(setShowModal({
            status:true,
            title:"Confirmation",
            type:"confirmOxygenDetailsUpdate",
            showCloseButton:false,
            data:{message:eligibilityResult?.message},
          }));
        }
        else{
          // Make api call to update the onboarding status
          await updateCustomerOnboardingStat(
            storePrecustomer.precustomer?.msisdn,
            "OTP SENT."
          );
          dispatch(setOtpLoading(false));
          customAlert.showToast("error", `${eligibilityResult?.message}` || "Failed to check eligibility");
          setRecheckEligibility(false);
        }

      }else{
        // Make api call to update the onboarding status
        await updateCustomerOnboardingStat(
          storePrecustomer.precustomer?.msisdn,
          "OTP SENT."
        );
        dispatch(setOtpLoading(false));
        customAlert.showToast("error", `${res?.message}` || "Failed to validate OTP");
      }

    }

    // to recheck eligibility:
    const handleRefreshEligibility = async() => {
      dispatch(setOtpLoading(true));
      const formData ={
        preCustomerId: String(storePrecustomer?.precustomer?.precustomerId),
      }

      // Eligibility check:
      const eligibilityResult = await checkEligibility(formData);

      if(eligibilityResult.status === true) {
        // Update precustomer
        dispatch(updatePrecustomer({
          precustomer:{
            ...storePrecustomer?.precustomer,
            precustomerId:storePrecustomer?.precustomer?.precustomerId,
            msisdn:storePrecustomer?.precustomer?.msisdn,
            eligibleAmount :eligibilityResult?.data?.eligible_amount,
            eligible_tenure:eligibilityResult?.data?.eligible_tenure,
            eligible:eligibilityResult?.data?.eligible
          },
          onboarding_status: "oxygen-device-bundles",
        }));
        
        // Make api call to update the onboarding status
        await updateCustomerOnboardingStat(
          storePrecustomer.precustomer?.msisdn,
          "ELIGIBILITY_PASS"
        );
        
        dispatch(setOtpLoading(false));
        customAlert.showToast("success", `${eligibilityResult?.message}`||"eligibility checked successfully");
        navigate("/oxygen-device-bundles");

      }else if(eligibilityResult?.status === false && eligibilityResult?.responseCode?.toLowerCase() === "pending"){
        // Make api call to update the onboarding status
        await updateCustomerOnboardingStat(
          storePrecustomer.precustomer?.msisdn,
          "OTP SENT."
        );
        dispatch(setOtpLoading(false));
        customAlert.showToast("error", `${eligibilityResult?.message}` || "Failed to check eligibility");
        setRecheckEligibility(true);
      }else if(eligibilityResult?.status === false && eligibilityResult?.responseCode?.toLowerCase() === "complete"){
        // Make api call to update the onboarding status
        await updateCustomerOnboardingStat(
          storePrecustomer.precustomer?.msisdn,
          "OTP SENT."
        );
        dispatch(setOtpLoading(false));
        customAlert.showToast("error", `${eligibilityResult?.message}` || "Failed to check eligibility");
        // confirmation modal
        dispatch(setShowModal({
          status:true,
          title:"Confirmation",
          type:"confirmOxygenDetailsUpdate",
          showCloseButton:false,
          data:{message:eligibilityResult?.message},
        }));
      }
      else{
        // Make api call to update the onboarding status
        await updateCustomerOnboardingStat(
          storePrecustomer.precustomer?.msisdn,
          "OTP SENT."
        );
        dispatch(setOtpLoading(false));
        customAlert.showToast("error", `${eligibilityResult?.message}` || "Failed to check eligibility");
        setRecheckEligibility(false);
      }
    }

    const actions = {handleResendOTP:handleResendOTP , handleProceed:handleProceed, consentText:"Enter OTP to Consent To the Provided Details for Retail customers (Oxygen)"} 
    
  return (
    <div>
      {
        recheckEligibility ? (
          <OxygenRecheckEligibilty handleRefresh={handleRefreshEligibility} loading={loading} />
        ) : (
          <OxygenOTPComponent {...actions}  />
        )
      }
    </div>
  )
}

export default OxygenFormOTP;